// Imports
import firebase from '../config/FirebaseConfig'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'

// Setup
const db = firebase.firestore()

// Get All By User
const getAllByUser = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('briefs').where('createdBy', '==', user.uid).orderBy('createdAt', 'desc').limit(100).get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

// Get All By Team
const getAllByTeam = async (teamId) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('briefs').where('teamId', '==', teamId).orderBy('createdAt', 'desc').limit(100).get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

// Get All Archived
const getAllArchived = async (teamId) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const createdByCondition = teamId ? ['teamId', '==', teamId] : ['createdBy', '==', user.uid]

  const snapshot = await db.collection('briefs').where(...createdByCondition).where('archived', '==', true).get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

// Get By ID
const getByID = async (briefId) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()
 
  const { data: response } = await AxiosConfig.get(`/fs/briefs/public/${briefId}`, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

const getPublicBrief = async (briefId) => {
  const { data: response } = await AxiosConfig.get(`/fs/briefs/public/${briefId}`)

  return response.data
}

// Mirrors briefWritableFields() in firestore.rules - any other key fails the create rule
const CREATABLE_FIELDS = [
  'name', 'createdAt', 'modifiedAt', 'teamId', 'createdBy', 'components', 'adIds', 'story', 'status',
  'dueDate', 'notes', 'brandProfileId', 'brandProfile', 'inspirationAds', 'generatedScript', 'archived'
]

// Create a Brief
const create = (payload) => {
  const user = firebase.auth().currentUser
  // Track Brief Creation
  window.analytics.track('Brief Created', {
    briefName: payload.name,
    briefId: payload.id
  })

  const briefData = {}
  CREATABLE_FIELDS.forEach((field) => {
    if (payload[field] !== undefined) briefData[field] = payload[field]
  })

  return db
    .collection('briefs')
    .add({ ...briefData, createdBy: user.uid, createdAt: +new Date() })
}

// Update Brief
const update = async (briefId, payload) => {
  return await db
    .collection('briefs')
    .doc(briefId)
    .update(payload)
}

// Remove/Delete Brief
const remove = async (briefId) => {
  return db.collection('briefs').doc(briefId).delete()
}

export default {
  create,
  getAllArchived,
  getAllByTeam,
  getAllByUser,
  getByID,
  getPublicBrief,
  remove,
  update
}
